<template>
  <div>
    <ConfirmDialog
      v-model="appDialog.confirm"
      :message="appDialog.message"
      :color="appDialog.color"
      :confirm-text="appDialog.confirmText"
      :cancel-text="appDialog.cancelText"
      @confirm-operation="confirmOperation"
      @cancel-operation="cancelOperation"
    />

    <WarningDialog
      v-model="appDialog.warn"
      :message="appDialog.message"
      @dismiss-dialog="closeAppDialog"
    />

    <ErrorDialog
      v-model="appDialog.error"
      :message="appDialog.message"
      @dismiss-dialog="closeAppDialog"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import WarningDialog from '@/components/dialogs/WarningDialog.vue';
import ErrorDialog from '@/components/dialogs/ErrorDialog.vue';
import hasAppDialog from '@/mixins/hasAppDialog';

export default {
  name: 'AppDialog',
  components: { ErrorDialog, WarningDialog, ConfirmDialog },
  mixins: [hasAppDialog],

  computed: {
    ...mapState(['appDialog']),
  },

  methods: {
    ...mapMutations(['setAppDialogVisible']),

    confirmOperation() {
      if (this.appDialog.confirmHandler) {
        this.appDialog.confirmHandler();
      }

      this.closeAppDialog();
    },

    cancelOperation() {
      if (this.appDialog.cancelHandler) {
        this.appDialog.cancelHandler();
      }

      this.closeAppDialog();
    },

    closeAppDialog() {
      this.setAppDialogVisible({
        confirm: false,
        warn: false,
        error: false,
      });
    },
  },
};
</script>

<style scoped>
</style>
